export default "__VITE_ASSET__CjAXjciF__"